import { useState } from 'react';
import { useHistory } from 'react-router-dom';

import { DoubleRightOutlined } from '@ant-design/icons';
import RibbonButton from 'common/components/button/RibbonButton';
import QaSpecAssignToSupplierModal from 'pages/qa-spec-workflow/components/modal/QaSpecAssignToSupplierModal';

import useToggleActiveRibbon from './hook';
import { useGetQaSpecDataHeader } from 'pages/qa-spec/query';

import Messages from 'i18n/messages/home';

const QASpecAssignSupplier = ({ productData }) => {
  const history = useHistory();

  const [visible, setVisible] = useState(false);

  const checkActiveContent = () => {
    const path = history?.location?.pathname;
    const regex = /\/product\/qa-specification\/\d+$/;
    return regex.test(path);
  };

  const isPathActive = checkActiveContent();
  const isActive = useToggleActiveRibbon(isPathActive);

  const { qaSpecDataHeader } = useGetQaSpecDataHeader({
    id: productData?.productId,
    isEnabled: !!productData?.productId,
  });

  const handleClick = () => {
    setVisible(true);
  };

  const isDisabledInitWorkflow =
    qaSpecDataHeader?.assignTo || !productData?.productId;

  return (
    <>
      {isActive && (
        <RibbonButton
          icon={<DoubleRightOutlined />}
          label={Messages.initWorkflow}
          onClick={handleClick}
          disabled={isDisabledInitWorkflow}
        />
      )}
      {visible && (
        <QaSpecAssignToSupplierModal
          visible={visible}
          setVisible={setVisible}
          isQaSpecPath={true}
        />
      )}
    </>
  );
};
export default QASpecAssignSupplier;
